// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"89b29b45","493":"63585755","994":"70d05e17"}[chunkId] + ".chunk.js";
};